import { type FunctionComponent } from "react";
import { Space } from "antd";

import { useTraineeProfile } from "~/modules/Trainee/TraineeProfile/scope";
import TraineeBadgesSection from "./TraineeBadgesSection";
import TraineeChallengesSection from "./TraineeChallengesSection";
import TraineeGoalsSection from "./TraineeGoalsSection";
import TraineeHabitsSection from "./TraineeHabitsSection";

const TraineeChallengesHabits: FunctionComponent = () => {
  // Czekamy na profil, bo `userId` trafia do zapisów nawyków i wyzwań.
  const { data: profile } = useTraineeProfile();

  if (!profile) {
    return null;
  }

  const { id: traineeId, userId } = profile;

  return (
    <Space direction="vertical" size={24} style={{ width: "100%", padding: 16 }}>
      <TraineeGoalsSection traineeId={traineeId} />
      <TraineeHabitsSection traineeId={traineeId} userId={userId ?? null} />
      <TraineeChallengesSection traineeId={traineeId} userId={userId ?? null} />
      <TraineeBadgesSection traineeId={traineeId} />
    </Space>
  );
};

export default TraineeChallengesHabits;
